













import {
  computed,
  defineComponent,
  ref,
} from '@vue/composition-api';

import { toCommaFormat } from '@/utils';

const ScrollableHorizontalBarChart = defineComponent({
  props: {
    xAxisLabel: { default: 'จำนวนรายการ' },
    yAxisLabel: { default: 'เขต' },
    height: {},
    width: {},
    data: { default: () => ([]) },
    labels: { default: () => ([]) },
    perPage: { type: Number, default: 5 },
  },
  setup(props) {
    const chart = ref(null);
    const startItem = ref(0);
    const options = {
      indexAxis: 'y',
      scales: {
        x: {
          title: {
            display: true,
            text: props.xAxisLabel,
          },
          ticks: {
            callback: (value: number) => `${toCommaFormat(value, 0, 0)}`,
          },
        },
        y: {
          min: 0,
          max: props.perPage,
          display: true,
          title: {
            display: true,
            text: props.yAxisLabel,
          },
          ticks: {
            maxRotation: 90,
            minRotation: 90,
          },
        },
      },
      plugins: {
        legend: {
          position: 'top',
          align: 'center',
        },
      },
    };

    const dataLength = computed(() => ((props.data as any)?.labels?.length || 0) as number);
    const displayLength = computed(() => (props.perPage + 1) || 0);
    const hiddenLength = computed(() => dataLength.value - displayLength.value);

    function scroll($event: any) {
      if (dataLength.value > 0 && displayLength.value > 0) {
        if (
          ($event.deltaY > 0)
          && startItem.value < hiddenLength.value
        ) {
          startItem.value += 1;
          (chart.value as any).updateY(1);
        } else if (
          ($event.deltaY < 0)
          && startItem.value > 0
        ) {
          startItem.value -= 1;
          (chart.value as any).updateY(-1);
        }
        (chart.value as any).rerenderChart();
      }
    }

    return {
      chart,
      scroll,
      options,
    };
  },
});

export default ScrollableHorizontalBarChart;
